import React from 'react';
import { FaHome, FaBriefcase, FaHistory, FaUser, FaCog, FaQuestionCircle, FaThLarge } from 'react-icons/fa';
import '../../styles/Dashboard.css';
import MenuItem from '../global/MenuItem'; // Import the custom MenuItem component

const Dashboard = () => {
  return (
    <div className="dash-board-page">
      <div className="dashboard-container">
        <div className="sidebar">
          <div className="sidebar-top">
            <MenuItem icon={FaThLarge} label="Dash Board" />
          </div>
          <div className="sidebar-menu">
            <MenuItem icon={FaHome} label="Home" />
            <MenuItem icon={FaBriefcase} label="Job Management" />
            <MenuItem icon={FaHistory} label="History" />
            <MenuItem icon={FaUser} label="My Profile" />
          </div>
          <div className="sidebar-bottom">
            <MenuItem icon={FaCog} label="Settings" />
            <MenuItem icon={FaQuestionCircle} label="Get Help" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
